import cx from 'classnames'
import _ from '@/utils/lodash-optimized'
import React from 'react'

import ValueRenderer from './ValueRenderer'
import './styles.scss'

const Item = ({ item }) => (
  <div
    key={item.id}
    className='key-value'
  >
    <span className='key'>{item.title}</span>
    <ValueRenderer
      value={item.value}
      type={item.type}
    />
  </div>
)

export class KeyValueSection extends React.Component {
  renderDebug () {
    const { section } = this.props
    return <pre>{JSON.stringify(section, null, 2)}</pre>
  }

  render () {
    const { section, debug, singleColumn } = this.props

    if (_.isNil(section)) {
      return null
    }

    const itemsCount = section.items.length
    const columnsClass = cx({
      keyValueSection: true,
      twoColumns: itemsCount > 7 && itemsCount < 14,
      threeColumns: itemsCount > 14,
      oneColumn: singleColumn
    })

    return (
      <div className={columnsClass}>
        {debug ? this.renderDebug() : null}
        {section.items
          ? section.items.map((item, index) => (
            <Item
              key={index}
              item={item}
            />
          ))
          : null}
      </div>
    )
  }
}
